const GRADIENTS = [
  "linear-gradient(135deg,#6366f1,#a855f7)",
  "linear-gradient(135deg,#0ea5e9,#22d3ee)",
  "linear-gradient(135deg,#f43f5e,#fb923c)",
  "linear-gradient(135deg,#10b981,#84cc16)",
  "linear-gradient(135deg,#8b5cf6,#ec4899)",
  "linear-gradient(135deg,#f59e0b,#ef4444)",
];

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h << 5) - h + s.charCodeAt(i);
  return Math.abs(h);
}

/** Deterministic initials avatar coloured from the identity string (email/name). */
export function Avatar({ name, small = false }: { name: string; small?: boolean }) {
  const label = (name || "?").trim();
  const initials = label.includes("@")
    ? label[0]?.toUpperCase() ?? "?"
    : label
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase() || "?";
  return (
    <span
      className={small ? "avatar sm" : "avatar"}
      style={{ background: GRADIENTS[hash(label) % GRADIENTS.length] }}
      title={label}
    >
      {initials}
    </span>
  );
}
